export default "__VITE_ASSET__C6QSloA1__"